export default __webpack_public_path__ + "static/media/star.1412dbee.svg";